export default "__VITE_ASSET__DUVZO4g8__"